(() => {
	angular.module('main').directive('mailList', [
		'$http',
		'$q',
		'messageService',
		'$filter',
		'$sce',
		'emailService',
		function($http, $q, messageService, $filter, $sce, emailService) {
			return {
				restrict: 'E',
				scope: {
					mails: '=',
					setClientMail: '&',
					viewIcon: '=',
					viewFunction: '&'
				},
				template: `
                <section>
                    <div class="mailList" ng-show="mails.length > 0">
                        <div class="table-responsive">
                            <table class="table table-strip table-mail-status">
                                <thead class="client_overview_head">
                                    <tr class="invoice-thead">
                                        <th>
                                            <b>Date</b>
                                        </th>
                                        <th>
                                            <b>To</b>
                                        </th>
                                        <th>
                                            <b>Subject</b>
                                        </th>
                                        <th width="100"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr ng-repeat="mailItem in mails | orderBy track by $index">
                                        <td class="text-nowrap">{{mailItem.date | timeFilter:'long'}}</td>
                                        <td class="text-nowrap">{{mailItem.toWhom | cutString: 15:mailItem.toWhom}}</td>
                                        <td>
                                            <div><strong>{{mailItem.from}}</strong></div>
                                            <div>{{mailItem.subject}}</div>
                                            <div ng-if="mailItem.status !=null">
                                            <div ng-show="mailItem.status==='sent'">
                                                    <span class="label label-orange-email">EMAIL SENT ON {{mailItem.statusOn !==null ? mailItem.statusOn : mailItem.date | timeFilter: 'long'| uppercase}}</span>
                                                    </div>
                    
                                                     <div ng-show="mailItem.status==='undelivered'">
                                                        <span class="mail-status__{{mailItem.status | lowercase}}">EMAIL UNDELIVERED</span>
                                                    </div>
                                                    <div ng-show="mailItem.status==='clicked'">
                                                        <span class="label label-primary">LINK CLICKED ON {{mailItem.statusOn | timeFilter: 'long'| uppercase}}</span>
                                                    </div>
                                                    <div ng-show="mailItem.status==='opened'">
                                                        <span class="label label-info">EMAIL OPENED ON {{mailItem.statusOn | timeFilter: 'long'| uppercase}}</span>
                                                    </div>
                                                    </div>
                                        </td>
                                        <td>
                                            <btn-view ng-click="getJobMailInfo(mailItem.id)"></btn-view>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
              </section>`,
				replace: true,
				transclude: true,
				link(scope) {
					scope.getJobMailInfo = function(jobMailId) {
						$http({
							method: 'GET',
							url: `/protected/rest/jobs/job/mail/?id=${jobMailId}`
						})
							.then(email => setMailData(email))
							.then(mailAssets => showReply(mailAssets))
							.catch(err => {
								if (err) {
									messageService.showDefaultErrorMessage(err);
								}
							});
					};

					function setMailData(result) {
						const deferred = $q.defer();

						if (!result.data || result.data.errorMessage) {
							deferred.reject(result.data ? result.data.errorMessage : null);
							return deferred.promise;
						}

						scope.jobMailData = result.data;
						scope.jobMailData.validMsg = true;

						// reply has't status, so we just show mail
						if (scope.jobMailData.status) {
							if (scope.jobMailData.to) {
								scope.jobMailData.to = parseEmail(scope.jobMailData.to);
							}
							if (scope.jobMailData.cc) {
								scope.jobMailData.cc = parseEmail(scope.jobMailData.cc);
							}
							scope.setClientMail({
								clientMail: null,
								jobMail: scope.jobMailData
							});
							$('#mailInfoModal').modal('show');
							deferred.resolve();
							return deferred.promise;
						}

						// fetch templates to write reply on client's reply
						return $q.all([
							$http.get('/protected/rest/email_templates/get/general'),
							$http.get('/protected/rest/email_templates/signature/get')
						]);

						function parseEmail(email) {
							return email
								.split(',')
								.map(mail => `${mail.trim()}\n`)
								.join('');
						}
					}

					function showReply(data) {
						if (Array.isArray(data)) {
							const [emailTemplates, signature] = data;
							const mailDataClient = setReplyData(
								scope.jobMailData,
								emailTemplates.data,
								signature.data
							);
							scope.jobMailData = angular.copy(mailDataClient);
							scope.setClientMail({
								clientMail: mailDataClient,
								jobMail: scope.jobMailData
							});
							$('#mailInfoModal').modal('show');
						}
					}

					function setReplyData(jobMailData, emailTemplates, signatureData) {
						const { subject, to, cc, date, allFromName, text } = jobMailData;
						const dateFilterSendEmailModal = "EEE, MMM dd, yyyy 'at' HH:mm a";
						const data = $filter('date')(date, dateFilterSendEmailModal);

						const mailDataClient = angular.copy(jobMailData);

						mailDataClient.emailSubject = subject;
						mailDataClient.emailTo = to;
						mailDataClient.emailCc = cc;
						mailDataClient.emails = emailTemplates;
						mailDataClient.mailSignature = signatureData.signature || '';
						mailDataClient.reply = true;
						mailDataClient.validMsg = true;

						try {
							// !!$sce.getTrustedHtml(text);

							const emailDetails = emailService.escapeEmailDetailsHtml(
								`On ${data} ${allFromName} wrote:`
							);
							const matchedText = emailService.trimStyleTagsHtml(
								emailService.escapeEmailTextHtml(text)
							);
							mailDataClient.emailTextReply = emailService.getEmailTextReply(
								emailDetails,
								emailService.escapeEmailBodyDetailsHtml(matchedText)
							);
							mailDataClient.emailText = emailService.getReplyText(
								mailDataClient
							);
						} catch (err) {
							console.log('error ', err);
							mailDataClient.emailTextReply =
								'Oops! This message is unsupported and cannot be displayed in Studio Ninja. Please view this message in your email provider';
							mailDataClient.validMsg = false;
						}

						return mailDataClient;
					}

					scope.setMinWidth = function(text) {
						if (text.length < 6) {
							return 40;
						} else if (text.length < 10) {
							return 60;
						} else if (text.length < 20) {
							return 100;
						}
						return 190;
					};
				}
			};
		}
	]);
})();



// WEBPACK FOOTER //
// ./web/js/components/mailList.js